import { AIS_VITRINY } from '@/lib/ais-ru-domen';
import { PRODUCTS } from '@/lib/products';

/** Ветки продуктов, которые middleware добавляет к внутреннему адресу. */
const SEGMENTS = PRODUCTS.map((p) => p.routeSegment).filter((s): s is string => Boolean(s));

/** Срезает `/<segment>` в начале пути; `null`, если пути он не принадлежит. */
function srezat(pathname: string, segment: string): string | null {
  if (pathname === `/${segment}`) return '/';
  if (pathname.startsWith(`/${segment}/`)) return pathname.slice(segment.length + 1);
  return null;
}

/**
 * Публичный путь из внутреннего, каким его видит посетитель.
 *
 * Срезаются обе внутренние части: ветка продукта (`/datahunter`,
 * `/aisearch`) и у AiSearch ещё ветка витрины (`/aisearch-tech`,
 * `/aisearch-ru`). Вторую раньше не срезали, и на заранее собранных
 * страницах .tech переключатель языка вёл на
 * `/ru/aisearch-tech/programs/dictation` — 404 на всех четырёх языках.
 * На страницах, которые рисуются по запросу (`/pricing`), утечки не было:
 * там next-intl видит адрес из браузера, а не внутренний.
 */
export function publichnyjPut(pathname: string): string {
  for (const segment of SEGMENTS) {
    const bezProdukta = srezat(pathname, segment);
    if (bezProdukta === null) continue;

    for (const vitrina of AIS_VITRINY) {
      const bezVitriny = srezat(bezProdukta, vitrina);
      if (bezVitriny !== null) return bezVitriny;
    }
    return bezProdukta;
  }

  return pathname;
}
